<template>
    <group-details :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-10">
            <page-loading v-if="!group"></page-loading>
            <template v-else>
                <group-billing-details :group="group" :isAdminOrOwner="isAdminOrOwner" />
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupBillingDetails from './GroupBillingDetails.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import GroupDetails from '../form/GroupDetails.vue';
import { ref, onMounted } from 'vue';
import { groupsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const group = ref(null);
const isAdminOrOwner = Spark.isAdminOrOwner;
const toasted = useToasted();

onMounted(async () => {
    try {
        const response = await groupsClient.getGroup({ teamId: props.teamId }, props.groupId);
        group.value = response.data;
    } catch (error) {
        console.error('Failed to fetch group:', error);
        toasted.error('Failed to load group details. Please try again.');
    }
});
</script>
